<template>   
    <div>
        <el-tabs v-model="activeName">
            <el-tab-pane label="用户管理" name="first"> </el-tab-pane>
            <el-tab-pane label="配置管理" name="second">菜单</el-tab-pane>
        </el-tabs>


        <div class="block">
            
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pageNum"
            :page-sizes="[10, 50, 100, 200]"
            :page-size="pageSize"
            layout="total,sizes, prev, pager, next,jumper"
            :total="total">
            </el-pagination>
        </div>

    </div>
</template>
<script>
import {Message} from 'element-ui';
export default {        
    ame:"detail",
    data(){
        return {
         
             params:{
                pageSize:10,
                pageNum:1
            },
            activeName:'first',
            totalPage:10,
            pageSize:10,
            total:1,
        }
    },
    props:['adminId'],
    methods:{
        loadTokenList(){
            this.params.adminId = this.adminId
            
        }, handleSizeChange(val) {
          this.params.pageSize = val;
          this.loadTokenList();
       },
       handleCurrentChange(val) {
          this.params.pageNum = val;
          this.loadTokenList();
       }
    },
    mounted(){
        this.loadTokenList()
    }
}
</script>
